import { render, staticRenderFns } from "./termsAdd.vue?vue&type=template&id=fd4ecc92&scoped=true&"
import script from "./termsAdd.vue?vue&type=script&lang=js&"
export * from "./termsAdd.vue?vue&type=script&lang=js&"
import style0 from "./termsAdd.vue?vue&type=style&index=0&id=fd4ecc92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4ecc92",
  null
  
)

export default component.exports